import { FC, ReactNode, useEffect, useState } from "react";
import { MasterDataTable } from "../../../components/DataTable/MasterDataTable";
import { TableColumn } from "react-data-table-component";
import moment from "moment";
import { Meeting, MeetingAttendance, VisitPermision } from "../../../interfaces/Meeting";
import { DateRangePicker } from "rsuite";
import { DeleteMeeting } from "../../../components/Meetings/DeleteMeeting";
import { MeetingAttachments } from "../../../components/Meetings/MeetingAttachments";
import { UpdateMeeting } from "../../../components/Meetings/UpdateMeeting";
import { AddPipeline } from "../../../components/Pipelines/BtnActionAddPipelineDropdown/AddPipeline";
import useUser from "../../../hooks/User";
import { UserScopeModal, defaultScope } from "../../../components/DataTable/UserScopeModal";
import { UserScope } from "../../../interfaces/UserScope";
import { useSettingsStore } from "../../../stores/SettingsStore";
import { IconButton, Menu, MenuItem } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import useSWR, { mutate } from "swr";
import { MapMeeting } from "../../../components/Meetings/MapMeeting";
import { CustomField } from "../../../interfaces/Settings";
import { FilterMeeting } from "../../../components/Meetings/FilterMeeting";
import { DataTableExport } from "../../../components/DataTable/DataTableExport";
import { UpdateStatusMeeting } from "../../../components/Meetings/UpdateStatusMeeting";
import { useIntl } from "react-intl";
import usePredefinedRanges from "../../../hooks/PredefinedRanges";
import useCalendarLocale from "../../../hooks/CalendarLocale";
import { customNumberFormat, customNumberFormatString, customThousandSeparatorDot } from "../../../functions/general";
import { endOfMonth, startOfMonth } from "date-fns";
import { DetailMeeting } from "../../../components/Meetings/DetailMeeting";
import { ExpandableElement } from "../../../components/General/ExpandableElement";
import axios from "axios";
import useAccessToken from "../../../hooks/AccessToken";
import { UpdateVisitMeeting } from "../../../components/Meetings/UpdateVisitMeeting";
import { DetailVisit } from "../../../components/Meetings/DetailVisit";
import { AddReimbursement } from "../../../components/Reimbursement/AddReimbursement";
import { OverlayTrigger, Tooltip as TooltipComp } from "react-bootstrap";
import { useCustomeStore } from "../../../stores/CustomeStore";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useMeetingStore } from "../../../stores/MeetingsStore";
import Select from 'react-select'
import useModalEffect from "../../../hooks/useModalEffect";
import { isAllowAddReimburse } from "../../../functions/reimbursement";
import useRedirectRouteNotif from "../../../stores/RedirectRouteNotif";
import { getSourceFilterDateOptions } from "../../../functions/getOptions";
import ButtonDropdownMeeting from "../../../components/Meetings/ButtonDropdownMeeting";
import AddScheduleMeeting from "../../../components/Meetings/add/AddScheduleMeeting";
import { SelectOption } from "../../../interfaces/SelectOption";
import { User } from "../../../interfaces/User";
import AddReportMeeting from "../../../components/Meetings/add/AddReportMeeting";
import AddVisitMeeting from "../../../components/Meetings/add/AddVisitMeeting";
import AddScheduleVisitMeeting from "../../../components/Meetings/add/AddScheduleVisitMeeting";
import LabelTooltipMeeting from "./LabelTooltipMeeting";
import DataTableImportMeeting from "../../../components/DataTable/DataTableImportExcel/DataTableImportMeeting";
import TooltipInfoApproval from "./TooltipInfoApproval";
import ModalApprovalMeeting from "./ModalApprovalMeeting";
import ModalClockInMeeting from "./ModalClockInMeeting";
import UpdateVisitScheduleMeeting from "../../../components/Meetings/update/UpdateVisitScheduleMeeting";
import { useReimbursementStore } from "../../../stores/ReimbursementStore";
import { getEndDate, getStartDate, getTypeDate } from "../../../functions/meetingDate";
import { useRouteStore } from "../../../stores/RouteStore";
import { returnStatusMeeting } from "../../../components/General/DetailMasterElement";
import { getStatusMeeting } from "../../../functions/meeting";

const today = new Date()
interface MasterMeetingsContentProps {
    merchantId?: string
}

const API_URL = process.env.REACT_APP_API_URL

const MasterMeetingsContent: FC<MasterMeetingsContentProps> = ({ merchantId }) => {
    const intl = useIntl()
    const user = useUser()
    const token = useAccessToken()
    const navigate = useNavigate()
    const { pathname } = useLocation()
    const { settings } = useSettingsStore()
    const { companyId } = useCustomeStore()
    const { templateMerchantId, templateMeetingId } = useParams()
    const { remainingLimitMonth, remainingLimitYear } = useReimbursementStore()
    const [startDate, setStartDate] = useState<Date | null>(null);
    const [endDate, setEndDate] = useState<Date | null>(null);
    const [typeDate, setTypeDate] = useState<string>("");
    const optionsTypeDate = getSourceFilterDateOptions(intl)
    const [loading, setLoading] = useState<boolean>(true);
    const [isMobile, setIsMobile] = useState<boolean>(false);
    const [showAddPipelineModal, setShowAddPipelineModal] = useState<boolean>(false);
    const [showAddReimbursementModal, setShowAddReimbursementModal] = useState<boolean>(false);
    const [showAttachmentModal, setShowAttachmentModal] = useState<boolean>(false);
    const [showUpdateModal, setShowUpdateModal] = useState<boolean>(false);
    const [showUpdateStatusModal, setShowUpdateStatusModal] = useState<boolean>(false);
    const [showDeleteModal, setShowDeleteModal] = useState<boolean>(false);
    const [showDetailVisitModal, setShowDetailVisitModal] = useState<boolean>(false);
    const [showMapModal, setShowMapModal] = useState<boolean>(false);
    const [showDetailModal, setShowDetailModal] = useState<boolean>(false);
    const [latitudeMap, setLatitudeMap] = useState<string>("");
    const [longitudeMap, setLongitudeMap] = useState<string>("");
    const [visit, setVisit] = useState<VisitPermision>({} as VisitPermision);
    const [meeting, setMeeting] = useState<Meeting>();
    const [user_id, setUser_id] = useState<string>(user.data.id);
    const [user_name, setUser_name] = useState<string>(user.data.name);
    const [scope, setScope] = useState<UserScope>(defaultScope(user.data.permission_meeting_read));
    const [openMenuId, setOpenMenuId] = useState<string | null>(null);
    const [customFields, setCustomFields] = useState<CustomField>({})
    const [showAttachmentCustomFieldModal, setShowAttachmentCustomFieldModal] = useState<boolean>(false);
    const [key, setKey] = useState<string>('');
    const [url, setUrl] = useState<string | string[]>('');
    const [manageColumns, setManageColumns] = useState<TableColumn<Meeting>[]>([]);
    const [isMounted, setIsMounted] = useState(false);
    const [codeUrl, setCodeUrl] = useState((pathname).split('/').pop());
    const { setSelectMultiMeeting, multiMeetings, selectMultiMeeting, typeMeeting, setTypeMeeting } = useMeetingStore()
    const predefinedRanges = usePredefinedRanges();
    const calendarLocale = useCalendarLocale();
    const { getTemplateId, clearRedirectRouteNotif } = useRedirectRouteNotif()
    const template = getTemplateId() || { id: '', templateId: '' }
    const [showModalAddScheduleMeeting, setShowModalAddScheduleMeeting] = useState<boolean>(false);
    const [showModalAddReportMeeting, setShowModalAddReportMeeting] = useState<boolean>(false);
    const [showModalAddVisitMeeting, setShowModalAddVisitMeeting] = useState<boolean>(false);
    const [showModalAddScheduleVisitMeeting, setShowModalAddScheduleVisitMeeting] = useState<boolean>(false);
    const [showModalInsertImportExcel, setShowModalInsertImportExcel] = useState<boolean>(false);
    const [usersData, setUsersData] = useState<SelectOption[]>([]);
    const [showModalApproval, setShowModalApproval] = useState<boolean>(false);
    const [showModalReject, setShowModalReject] = useState<boolean>(false);
    const [showModalClockIn, setShowModalClockIn] = useState<boolean>(false);
    const [showModalUpdateVisitSchedule, setShowModalUpdateVisitSchedule] = useState<boolean>(false);
    const [typeApproval, setTypeApproval] = useState<'approve' | 'reject'>('' as 'approve' | 'reject');
    const { prevRoute } = useRouteStore()

    const fetcher = (url: string) => axios.get(url, {
        headers: {
            'X-Auth-token': token
        }
    }).then(res => res.data.data)

    const getUserURL = () => {
        if (user.data.permission_pipeline_read === "ALL" && settings.is_superadmin_allowed_as_pic) {
            return `${API_URL}user/company`
        } else if (user.data.permission_pipeline_read === "ALL") {
            return `${API_URL}users`
        } else {
            return `${API_URL}user/subordinates`
        }
    }

    const { data: checkVisit = [], isLoading: checkVisitLoading } = useSWR(`${API_URL}visits/insert-permission`, fetcher)
    const { data: meetingData = {}, isLoading } = useSWR(template.id && template.templateId ? `${API_URL}v2/meetings/${template.id}` : null, fetcher);
    const { data: users = [], error: usersError, isLoading: usersLoading } = useSWR(getUserURL(), fetcher)
    const { data: labels = [], error: labelsError, isLoading: labelsLoading } = useSWR(`${API_URL}labels?usableBy[]=meeting`, fetcher)
    const { data: usersCompany = [], error: usersCompanyError, isLoading: usersCompanyLoading } = useSWR(`${API_URL}calendars/company?includeSelf=true`, fetcher)
    const { data: pipelinesAbandoned = [], error: pipelinesAbandonedError, isLoading: pipelinesAbandonedLoading } = useSWR(`${API_URL}abandoned-leads?leadAge=5`, fetcher)

    useEffect(() => {
        if (!usersLoading) {
            const usersData = users.map((user: User) => ({
                value: user.id,
                label: user.name
            }));

            if (user.data.permission_meeting_create !== "ALL") {
                usersData.unshift({ value: user.data.id, label: user.data.name })
            }

            setUsersData(usersData);
        }
    }, [users]);

    useEffect(() => {
        if (!checkVisitLoading) {
            setVisit({ permission: checkVisit.permission, id: checkVisit.id, customFields: checkVisit.customFields })
        }
    }, [checkVisit])

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth < 666) {
                setIsMobile(true);
            } else {
                setIsMobile(false);
            }
        };

        // Initial check
        handleResize();

        window.addEventListener("resize", handleResize);

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    const handleClick = (menuId: string) => {
        setOpenMenuId(menuId);
    };
    const handleClose = () => {
        setOpenMenuId(null);
    };

    const onRowClicked = (row: Meeting) => {
        setMeeting(row)
        setShowDetailModal(true);
    };

    let tableColumns: TableColumn<Meeting>[] = [
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.ACTION' }),
            center: true,
            width: '70px',
            id: 'fixedLeft',
            cell: (row) => {
                return (
                    <>
                        <IconButton
                            aria-label={`more-${row.id}`}
                            id={`menu-anchor-${row.id}`}
                            onClick={() => handleClick(row.id)}
                        >
                            <MoreVertIcon />
                        </IconButton>

                        <Menu
                            id={`menu-${row.id}`}
                            anchorEl={document.getElementById(`menu-anchor-${row.id}`)}
                            open={openMenuId === row.id}
                            onClose={handleClose}
                            disableScrollLock={true}
                        >
                            {
                                (!row.meeting_is_pipeline) && (user.data.is_superadmin || user.data.permission_pipeline_create !== 'NONE') && row.meeting_status === intl.formatMessage({ id: 'MEETING.STATUS.FINISHED' }) &&
                                <MenuItem
                                    disabled={settings.pipeline_abandoned_lock && pipelinesAbandoned.length > 0}
                                    onClick={() => {
                                        handleClose();
                                        setShowAddPipelineModal(true);
                                        setMeeting(row);
                                    }}>
                                    <i className="fas fa-plus fs-4 me-4"></i>
                                    <span>{settings.pipeline_title}</span>
                                </MenuItem>
                            }

                            {
                                user.data.id === row.owner_id &&
                                <OverlayTrigger placement="right" overlay={<TooltipComp id="tooltip-labels" hidden={isAllowAddReimburse(remainingLimitYear, remainingLimitMonth)}>{intl.formatMessage({ id: "FORM.LABEL.LIMIT_REACHED" })}</TooltipComp>} >
                                    <div style={{ display: 'inline-block', cursor: isAllowAddReimburse(remainingLimitYear, remainingLimitMonth) ? 'pointer' : 'not-allowed' }} >
                                        <MenuItem
                                            disabled={!isAllowAddReimburse(remainingLimitYear, remainingLimitMonth)}
                                            onClick={() => {
                                                if (isAllowAddReimburse(remainingLimitYear, remainingLimitMonth)) {
                                                    handleClose();
                                                    setShowAddReimbursementModal(true);
                                                    setMeeting(row);
                                                }
                                            }}
                                            style={{ pointerEvents: 'auto' }}
                                        >
                                            <i className="fas fa-plus fs-4 me-4"></i>
                                            <span>{intl.formatMessage({ id: 'FORM.ACTION.REIMBURSEMENTS' })}</span>
                                        </MenuItem>
                                    </div>
                                </OverlayTrigger>
                            }

                            {
                                (user.data.is_superadmin || user.data.permission_meeting_update !== 'NONE') &&
                                <MenuItem onClick={() => {
                                    handleClose();
                                    if (row.type === 'SCHEDULED_VISIT') {
                                        setShowModalUpdateVisitSchedule(true);
                                    } else {
                                        setShowUpdateStatusModal(true);
                                    }
                                    setMeeting(row);
                                }}>
                                    <i className="fas fa-edit fs-4 me-4"></i>
                                    <span>{intl.formatMessage({ id: 'FORM.ACTION.UPDATE' })}</span>
                                </MenuItem>
                            }

                            {
                                (user.data.is_superadmin || user.data.permission_meeting_delete !== 'NONE') &&
                                <MenuItem onClick={() => {
                                    handleClose();
                                    setShowDeleteModal(true);
                                    setMeeting(row);
                                }}>
                                    <i className="fas fa-trash fs-4 me-4"></i>
                                    <span>{intl.formatMessage({ id: 'FORM.ACTION.DELETE' })}</span>
                                </MenuItem>
                            }

                            {
                                row.type === 'SCHEDULED_VISIT' && (user.data.is_superadmin || row.isPermittedToApprove) && row.meeting_status !== intl.formatMessage({ id: 'MEETING.STATUS.FINISHED' }) && row.meeting_status !== intl.formatMessage({ id: 'MEETING.STATUS.CANCELLED' }) && row.meeting_status === intl.formatMessage({ id: 'MEETING.STATUS.PENDING' }) &&
                                <MenuItem onClick={() => {
                                    handleClose();
                                    setShowModalApproval(true);
                                    setMeeting(row);
                                    setTypeApproval('approve');
                                }}>
                                    <i className="fas fa-check fs-4 me-4"></i>
                                    <span>{intl.formatMessage({ id: 'FORM.ACTION.APPROVE' })}</span>
                                </MenuItem>
                            }

                            {
                                row.type === 'SCHEDULED_VISIT' && (user.data.is_superadmin || row.isPermittedToApprove) && row.meeting_status !== intl.formatMessage({ id: 'MEETING.STATUS.FINISHED' }) && row.meeting_status !== intl.formatMessage({ id: 'MEETING.STATUS.CANCELLED' }) && row.meeting_status === intl.formatMessage({ id: 'MEETING.STATUS.PENDING' }) &&
                                <MenuItem onClick={() => {
                                    handleClose();
                                    setShowModalReject(true);
                                    setMeeting(row);
                                    setTypeApproval('reject');
                                }}>
                                    <i className="fas fa-times fs-4 me-4"></i>
                                    <span>{intl.formatMessage({ id: 'FORM.ACTION.REJECT' })}</span>
                                </MenuItem>
                            }

                            {
                                row.type === 'SCHEDULED_VISIT' && user.data.id === row.owner_id && row.meeting_status !== intl.formatMessage({ id: 'MEETING.STATUS.FINISHED' }) && (
                                    <MenuItem
                                        disabled={row.meeting_status === intl.formatMessage({ id: 'MEETING.STATUS.PENDING' }) || !visit.permission || row.meeting_status === intl.formatMessage({ id: 'MEETING.STATUS.REJECTED' })}
                                        onClick={() => {
                                            handleClose();
                                            setShowModalClockIn(true);
                                            setMeeting(row);
                                        }}>
                                        <i className="fas fa-walking fs-4 me-4"></i>
                                        <span>{intl.formatMessage({ id: 'FORM.ACTION.VISIT_IN' })}</span>
                                    </MenuItem>
                                )
                            }

                            {
                                (row.type === 'VISIT' || (row.type === 'SCHEDULED_VISIT' && (row.meeting_status === intl.formatMessage({ id: 'MEETING.STATUS.ONGOING' }) || row.meeting_status === intl.formatMessage({ id: 'MEETING.STATUS.FINISHED' })))) &&
                                <MenuItem onClick={() => {
                                    handleClose();
                                    setShowDetailVisitModal(true);
                                    setMeeting(row);
                                }}>
                                    <i className="fas fa-info-circle fs-4 me-4"></i>
                                    <span>{intl.formatMessage({ id: 'FORM.ACTION.VISIT_DETAIL' })}</span>
                                </MenuItem>
                            }
                        </Menu>
                    </>
                )
            },
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.ACTION' }))?.omit
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PHOTO' }),
            style: { cursor: "pointer" },
            width: '70px',
            center: true,
            reorder: true,
            cell: (row) => {
                if (row.attachments !== null && row.attachments.length > 0) {
                    return (
                        <span role="button" onClick={
                            () => {
                                setShowAttachmentModal(true);
                                setMeeting(row);
                            }
                        }>
                            <i className="fas fs-2 fa-eye"></i>
                        </span>
                    )
                } else return "-"
            },
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PHOTO' }))?.omit
        },
        {
            name: settings.merchant_title,
            style: { cursor: "pointer" },
            width: '250px',
            selector: row => row.merchant_name?.toLowerCase() ?? "-",
            sortable: true,
            cell: (row) => {
                if (row.type === "VISIT") {
                    return (
                        <div className="d-flex flex-row gap-2 justify-content-center align-items-center">
                            <span>{row.merchant_name}</span>
                            {selectMultiMeeting.isFeatureLabelEnabled && (
                                <div>
                                    <LabelTooltipMeeting row={row} />
                                </div>
                            )}
                        </div>
                    )
                } else if (row.type === "SCHEDULED_VISIT") {
                    return (
                        <>
                            <div className="d-flex flex-row gap-2 justify-content-center align-items-center">
                                <span>{row.merchant_name}</span>
                                {selectMultiMeeting.isFeatureLabelEnabled && (
                                    <div className="d-flex flex-row gap-2 justify-content-center align-items-center">
                                        <LabelTooltipMeeting row={row} />
                                    </div>
                                )}
                                {
                                    (row.meeting_status === intl.formatMessage({ id: 'MEETING.STATUS.PENDING' }) || row.approval?.reason) && (
                                        <TooltipInfoApproval reason={row.approval?.reason} />
                                    )
                                }
                            </div>
                        </>
                    );
                } else {
                    return (
                        <div className="d-flex flex-row gap-2">
                            <div>
                                {row.merchant_name}
                            </div>
                            {selectMultiMeeting.isFeatureLabelEnabled && (
                                <div>
                                    <LabelTooltipMeeting row={row} />
                                </div>
                            )}

                        </div>
                    )
                }
            },
            reorder: true,
            omit: manageColumns.find(item => item.name === settings.merchant_title)?.omit
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.STATUS' }),
            style: { cursor: "pointer" },
            width: '200px',
            center: true,
            selector: row => row.meeting_status,
            cell(row) {
                return returnStatusMeeting(row, intl)
            },
            sortable: true,
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.STATUS' }))?.omit
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.TYPE' }),
            style: { cursor: "pointer" },
            width: '200px',
            selector: row => row.typeString?.toLowerCase() ?? "-",
            sortable: true,
            cell: row => row.typeString,
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.TYPE' }))?.omit
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PIC' }),
            style: { cursor: "pointer" },
            width: '200px',
            selector: row => row.owner_name?.toLowerCase() ?? "-",
            sortable: true,
            cell: row => row.owner_name,
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PIC' }))?.omit
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_CREATED' }),
            style: { cursor: "pointer" },
            width: '150px',
            selector: row => row.date_created,
            sortable: true,
            cell: (row) => {
                if (row.date_created === null) return "-"
                else return row.allDay ? moment(row.date_created).format("DD MMM YYYY") : moment(row.date_created).format("DD MMM YYYY HH:mm")
            },
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_CREATED' }))?.omit
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_STARTED' }),
            style: { cursor: "pointer" },
            width: '150px',
            selector: row => row.date_meet,
            sortable: true,
            cell: (row) => {
                return (
                    row.allDay ? moment(row.date_meet).format("DD MMM YYYY") : moment(row.date_meet).format("DD MMM YYYY HH:mm")
                )
            },
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_STARTED' }))?.omit
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_ENDED' }),
            style: { cursor: "pointer" },
            width: '150px',
            selector: row => row.date_meet_end,
            sortable: true,
            cell: (row) => {
                if (row.date_meet_end === null) return "-"
                else return row.allDay ? moment(row.date_meet_end).format("DD MMM YYYY") : moment(row.date_meet_end).format("DD MMM YYYY HH:mm")
            },
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DATE_ENDED' }))?.omit
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PARTICIPANT' }),
            style: { cursor: "pointer" },
            width: '150px',
            selector: row => row.attendees?.length > 0 ? row.attendees.map((data: MeetingAttendance) => data.name).join(', ') : "-",
            sortable: true,
            cell: (row) => {
                return (
                    row.attendees?.length > 0 ? row.attendees.map((data: MeetingAttendance) => data.name).join(', ') : "-"
                )
            },
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.PARTICIPANT' }))?.omit
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.CREATED_BY' }),
            style: { cursor: "pointer" },
            width: "200px",
            selector: row => row.creator_name?.toLowerCase() ?? "-",
            sortable: true,
            cell: row => row.creator_name,
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.CREATED_BY' }))?.omit
        },
        {
            name: user?.data.company_id === companyId.maxy ? intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DISCUSSION_NOTES' }) : intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NOTES' }),
            style: { cursor: "pointer" },
            width: "250px",
            selector: row => row.note?.toLowerCase() ?? '-',
            cell: row => {
                if (row.note) {
                    var data = (row.note).replaceAll("\n", "<br/>")
                    return <ExpandableElement text={data} maxHeight={100} />;
                } else return '-'
            },
            reorder: true,
            omit: manageColumns.find(item => item.name === (user?.data.company_id === companyId.maxy ? intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.DISCUSSION_NOTES' }) : intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.NOTES' })))?.omit
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.LOCATION' }),
            style: { cursor: "pointer" },
            width: '600px',
            selector: row => row.location,
            reorder: true,
            cell: (row) => {
                return (
                    <>
                        {
                            row.latitude && row.longitude ?
                                <span>
                                    {row.location}
                                    <i
                                        className="fas fs-5 fa-map-marker-alt ms-3 cursor-pointer text-hover-primary"
                                        onClick={() => {
                                            setShowMapModal(true);
                                            setLatitudeMap(row.latitude);
                                            setLongitudeMap(row.longitude);
                                            setMeeting(row);
                                        }}
                                    ></i>
                                </span>
                                :
                                <b>-</b>
                        }
                    </>
                )
            },
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.LOCATION' }))?.omit
        },
        {
            name: intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.REMINDER' }),
            style: { cursor: "pointer" },
            width: '150px',
            center: true,
            selector: row => row.reminderMinutes === null ? "-" : customNumberFormat(parseInt(row.reminderMinutes)) + " Menit",
            sortable: true,
            reorder: true,
            omit: manageColumns.find(item => item.name === intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.REMINDER' }))?.omit
        },
    ];

    if (merchantId) {
        tableColumns = tableColumns.filter((column) => column.name !== intl.formatMessage({ id: 'MASTERS.DATATABLE.COLUMNS.ACTION' }))
    }

    const tableColumnsWithCustomFields: TableColumn<Meeting>[] = [
        ...tableColumns,
        ...Object.keys(customFields).map((key, index) => {
            if (customFields[key].type === 'date') {
                return {
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    selector: (row: Meeting) => {
                        return row.custom_fields && row.custom_fields[key] ? row.custom_fields[key] as string : '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                    cell: (row: Meeting) => {
                        if (row.custom_fields && row.custom_fields[key]) {
                            return moment(row.custom_fields[key]).format("DD MMM YYYY")
                        } else {
                            return '-'
                        }
                    }
                };
            } else if (customFields[key].type === 'image' || customFields[key].type === 'images') {
                return {
                    width: "70px",
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    center: true,
                    selector: (row: Meeting) => {
                        return row.custom_fields && row.custom_fields[key] ? row.custom_fields[key] as string : '-';
                    },
                    cell: (row: Meeting) => {
                        if (row.custom_fields && row.custom_fields[key]) {
                            return (
                                <span role="button" onClick={
                                    () => {
                                        setShowAttachmentCustomFieldModal(true);
                                        setMeeting(row);
                                        setKey(key);
                                        setUrl(row.custom_fields[key] as any);
                                    }
                                }>
                                    <i className="fas fs-2 fa-eye"></i>
                                </span>
                            )
                        } else {
                            return '-'
                        }
                    },
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                }
            } else if (customFields[key].type === 'file' || customFields[key].type === 'files' || customFields[key].type === 'video' || customFields[key].type === 'videos') {
                return {
                    width: "70px",
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    center: true,
                    selector: (row: Meeting) => {
                        return row.custom_fields && row.custom_fields[key] ? row.custom_fields[key] as string : '-';
                    },
                    cell(row: Meeting) {
                        const fileUrl = row.custom_fields && row.custom_fields[key];
                        if (typeof fileUrl === "string") {
                            return fileUrl ? (
                                <a
                                    href={fileUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                    className="ms-2 btn btn-sm btn-icon btn-bg-light btn-active-color-primary"
                                >
                                    <i className="fas fa-file-invoice fs-3 float-end"></i>
                                </a>
                            ) : '-';
                        } else {
                            return fileUrl ? (
                                <span role="button" onClick={() => {
                                    setShowAttachmentCustomFieldModal(true);
                                    setMeeting(row);
                                    setKey(key);
                                    setUrl(fileUrl as string[]);
                                }}>
                                    <i className="fas fa-file-invoice fs-3 float-end"></i>
                                </span>
                            ) : '-';
                        }
                    },
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                }
            } else if (customFields[key].type === 'multiple' || customFields[key].type === 'multipleOption') {
                return {
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    selector: (row: Meeting) => row.custom_fields && row.custom_fields[key] ? row.custom_fields[key].toString() : '-',
                    cell: (row: Meeting) => {
                        const values = row.custom_fields && row.custom_fields[key] && row.custom_fields[key].toString()
                        if (customFields[key].type === 'multipleOption') {
                            return values ? (
                                <div style={{ whiteSpace: 'pre-wrap' }}>
                                    <div>{values.split(',').join(', ')}</div>
                                </div>
                            ) : "-"
                        } else return values ? values.split(',').join(', ') : '-'
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                };
            } else if (customFields[key].type === 'link') {
                return {
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    cell: (row: Meeting) => {
                        if (row.custom_fields && row.custom_fields[key]) {
                            return (
                                <a href={row.custom_fields[key] as string} rel="noreferrer" className="btn btn-sm btn-outline btn-outline-default btn-active-light text-gray-600" target="_blank">Lihat<i className="fas fa-external-link-alt fs-6 ms-2 p-0"></i></a>
                            )
                        } else return "-"
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                };
            } else if (customFields[key].type === 'serial') {
                return {
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    cell: (row: Meeting) => {
                        const values = row.custom_fields && row.custom_fields[key];
                        return values ? (values as string[]).join('') : '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                };
            } else if (customFields[key].type === 'number') {
                return {
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    selector: (row: Meeting) => row.custom_fields && row.custom_fields[key] ? customThousandSeparatorDot(row.custom_fields[key] as unknown as number) : '-',
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                }
            } else if (customFields[key].type === 'dateTimeRange') {
                return {
                    id: key,
                    name: customFields[key].name,
                    selector: (row: Meeting) => {
                        return row.custom_fields && row.custom_fields[key] ? (row.custom_fields[key] as string[]).map((item: any) => item).join(' - ') : '-'
                    },
                    width: "200px",
                    cell: (row: Meeting) => {
                        if (row.custom_fields && row.custom_fields[key]) {
                            return Array.isArray(row.custom_fields[key]) && (row.custom_fields[key] as string[]).map((item: any) => moment(item).format('DD MMM YYYY HH:mm')).join(' - ')
                        } else {
                            return '-'
                        }
                    },
                    sortable: true,
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                }
            } else if (customFields[key].type === 'time') {
                return {
                    id: key,
                    name: customFields[key].name,
                    width: '150px',
                    selector: (row: Meeting) => {
                        return row.custom_fields && row.custom_fields[key] ? row.custom_fields[key] as string : '-';
                    },
                    cell: (row: Meeting) => {
                        return row.custom_fields && row.custom_fields[key] ? moment(row.custom_fields[key]).format('HH:mm') : '-';
                    },
                    sortable: true,
                    reorder: true,
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                }
            } else if (customFields[key].type === 'merchant') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Meeting) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Meeting) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => item.merchant_name).join(', ');
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit
                };
            } else if (customFields[key].type === 'pipeline') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Meeting) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Meeting) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return (
                                <div className="d-flex flex-column">
                                    <span><b>{(values[0] as any).name}</b> / </span>
                                    <span>{(values[0] as any).nominal} / </span>
                                    <span>{moment((values[0] as any).dateCreated).format("DD MMM YYYY")}</span>
                                </div>
                            );
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                };
            } else if (customFields[key].type === 'meeting') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Meeting) => {
                        return row.custom_fields && row.custom_fields[key] ? row.custom_fields[key].toString() : '-'
                    },
                    cell: (row: Meeting) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => `${item.merchant_name} / ${moment(item.date_meet).format('DD MMM YYYY')} / ${item.meeting_status}`).join(', ');
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                };
            } else if (customFields[key].type === 'user') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Meeting) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Meeting) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => item.name).join(', ');
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                };
            } else if (customFields[key].type === 'dateTime') {
                return {
                    id: key,
                    name: customFields[key].name,
                    selector: (row: Meeting) => {
                        return row.custom_fields && row.custom_fields[key] ? row.custom_fields[key] as string : '-';
                    },
                    cell: (row: Meeting) => {
                        return row.custom_fields && row.custom_fields[key] ? moment(row.custom_fields[key]).format('DD MMM YYYY HH:mm') : '-'
                    },
                    sortable: true,
                    reorder: true,
                    width: "200px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                };
            } else if (customFields[key].type === 'product') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Meeting) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Meeting) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => item.product_name).join(', ');
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns[index + 25] ? manageColumns[index + 25].omit : false
                };
            } else if (customFields[key].type === 'option') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    selector: (row: Meeting) => {
                        const fieldValue = row.custom_fields && (row.custom_fields[key] as string);
                        const displayValue = fieldValue && typeof fieldValue === 'object' && Object.keys(fieldValue).length === 0
                            ? '-'
                            : fieldValue;

                        return displayValue || '-';
                    },
                    cell: (row: Meeting) => {
                        const values = row.custom_fields && row.custom_fields[key] && row.custom_fields[key].toString();
                        return values ? (
                            <div style={{ whiteSpace: 'pre-wrap' }}>
                                <div>{values}</div>
                            </div>
                        ) : "-"
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                };
            } else if (customFields[key].type === 'product') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Meeting) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Meeting) => {
                        const values = row.info_custom_fields && row.info_custom_fields[key];
                        if (Array.isArray(values) && values.length > 0) {
                            return values.map((item: any) => item.product_name).join(', ');
                        }
                        return '-';
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                };
            } else if (customFields[key].type === 'paragraph') {
                return {
                    id: key,
                    name: customFields[key].name,
                    style: { cursor: "pointer" },
                    grow: 2,
                    selector: (row: Meeting) => {
                        return row.info_custom_fields && row.info_custom_fields[key] ? row.info_custom_fields[key].toString() : '-'
                    },
                    cell: (row: Meeting) => {
                        const values = row.custom_fields && row.custom_fields[key] && row.custom_fields[key].toString();
                        return values ? (
                            <ExpandableElement
                                content={
                                    <div style={{ whiteSpace: 'pre-wrap' }}>
                                        {values}
                                    </div>
                                }
                                maxHeight={100}
                            />
                        ) : "-"
                    },
                    sortable: true,
                    reorder: true,
                    width: "150px",
                    omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                };
            }

            return {
                id: key,
                name: customFields[key].name,
                style: { cursor: "pointer" },
                selector: (row: Meeting) => {
                    // Check if row.custom_fields is defined and not null
                    const fieldValue = row.custom_fields && row.custom_fields[key];
                    // Check if fieldValue is an object and not null
                    const displayValue = fieldValue && typeof fieldValue === 'object' && Object.keys(fieldValue).length === 0
                        ? '-'
                        : fieldValue;

                    return (displayValue as string)?.toLowerCase() || '-';
                },
                allowOverflow: true,
                sortable: true,
                width: "150px",
                omit: manageColumns.find(item => item.name === customFields[key].name)?.omit,
                cell: (row: Meeting) => {
                    // Check if row.custom_fields is defined and not null
                    const fieldValue = row.custom_fields && row.custom_fields[key];

                    // Check if fieldValue is an object and not null
                    const displayValue = fieldValue && typeof fieldValue === 'object' && Object.keys(fieldValue).length === 0
                        ? '-'
                        : fieldValue;

                    return displayValue || '-';
                },
                reorder: true
            };
        }),
    ];

    let actions: ReactNode[] = [];
    if (user.data.is_allowed_export_excel) {
        actions.push(
            <DataTableExport source={"Meeting"} columns={manageColumns} />,
        )
    }
    if (user.data.permission_meeting_create !== 'NONE' && !merchantId) {
        if (visit.permission) actions.push
            (
                <DataTableImportMeeting usersCompany={usersCompany} codeUrl={templateMeetingId || ''} labels={labels} customFields={customFields} typeAction="insert" typeMeeting={typeMeeting} setShowModalInsertImportExcel={setShowModalInsertImportExcel} users={users} />,
                <ButtonDropdownMeeting setTypeMeeting={setTypeMeeting} setShowModalAddReportMeeting={setShowModalAddReportMeeting} setShowModalAddScheduleMeeting={setShowModalAddScheduleMeeting} setShowModalAddVisitMeeting={setShowModalAddVisitMeeting} setShowModalAddScheduleVisitMeeting={setShowModalAddScheduleVisitMeeting} />
            );
        else actions.push(<UpdateVisitMeeting codeUrl={templateMeetingId || ''} idMeeting={visit.id} setVisit={setVisit} visit={visit} />)
    }
    actions.push(<FilterMeeting manageColumns={manageColumns} setManageColumns={setManageColumns} />);

    useEffect(() => {
        setManageColumns(tableColumnsWithCustomFields);
    }, [customFields])

    useModalEffect({
        showModal: showAddPipelineModal,
        setShowModal: setShowAddPipelineModal,
        modalId: `add-pipeline-modal`
    })

    useModalEffect({
        showModal: showAddReimbursementModal,
        setShowModal: setShowAddReimbursementModal,
        modalId: `add-reimbursement-modal`
    })

    useModalEffect({
        showModal: showAttachmentModal,
        setShowModal: setShowAttachmentModal,
        modalId: `attachments-meeting-modal-${meeting?.id}`
    })

    useModalEffect({
        showModal: showUpdateStatusModal,
        setShowModal: setShowUpdateStatusModal,
        modalId: `update-status-meeting-modal-${meeting?.id}`
    })

    useModalEffect({
        showModal: showUpdateModal,
        setShowModal: setShowUpdateModal,
        modalId: `update-meeting-modal-${meeting?.id}`
    })

    useModalEffect({
        showModal: showDeleteModal,
        setShowModal: setShowDeleteModal,
        modalId: `delete-meeting-modal-${meeting?.id}`
    })

    useModalEffect({
        showModal: showMapModal,
        setShowModal: setShowMapModal,
        modalId: `map-meeting-modal-${meeting?.id}`
    })

    useModalEffect({
        showModal: showAttachmentCustomFieldModal,
        setShowModal: setShowAttachmentCustomFieldModal,
        modalId: `attachments-meeting-modal-${meeting?.id}`
    })

    useModalEffect({
        showModal: showDetailModal,
        setShowModal: setShowDetailModal,
        modalId: `detail-meeting-modal`
    })

    useModalEffect({
        showModal: showDetailVisitModal,
        setShowModal: setShowDetailVisitModal,
        modalId: `detail-visit-modal-${meeting?.id}`
    })

    useModalEffect({
        showModal: showModalAddScheduleMeeting,
        setShowModal: setShowModalAddScheduleMeeting,
        modalId: 'add-schedule-meeting-modal'
    })

    useModalEffect({
        showModal: showModalAddReportMeeting,
        setShowModal: setShowModalAddReportMeeting,
        modalId: 'add-report-meeting-modal'
    })

    useModalEffect({
        showModal: showModalAddVisitMeeting,
        setShowModal: setShowModalAddVisitMeeting,
        modalId: 'add-visit-meeting-modal'
    })

    useModalEffect({
        showModal: showModalAddScheduleVisitMeeting,
        setShowModal: setShowModalAddScheduleVisitMeeting,
        modalId: 'add-schedule-visit-meeting-modal'
    })

    useModalEffect({
        showModal: showModalInsertImportExcel,
        setShowModal: setShowModalInsertImportExcel,
        modalId: 'import-excel-template-meeting-modal'
    })

    useModalEffect({
        showModal: showModalUpdateVisitSchedule,
        setShowModal: setShowModalUpdateVisitSchedule,
        modalId: `update-visit-schedule-meeting-modal-${meeting?.id}`
    })

    useModalEffect({
        showModal: showModalClockIn,
        setShowModal: setShowModalClockIn,
        modalId: `update-clockin-visit-schedule-meeting-modal-${meeting?.id}`
    })

    useModalEffect({
        showModal: showModalApproval,
        setShowModal: setShowModalApproval,
        modalId: `${typeApproval}-meeting-modal-${meeting?.id}`
    })

    useModalEffect({
        showModal: showModalReject,
        setShowModal: setShowModalReject,
        modalId: `${typeApproval}-meeting-modal-${meeting?.id}`
    })

    useEffect(() => {
        if (!isLoading) {
            if (meetingData && Object.keys(meetingData).length > 0) {
                const newMeetingData = {
                    ...meetingData,
                    meeting_status: getStatusMeeting({ ...meetingData, meeting_status: meetingData.status }, intl)
                }
                setShowDetailModal(true)
                setMeeting(newMeetingData);
            }

            if (meeting) clearRedirectRouteNotif()
        }
        return () => {
            setShowDetailModal(false)
            setMeeting({} as Meeting)
        }
    }, [isLoading, showDetailModal])

    useEffect(() => {
        if (isMounted) {
            if (startDate && endDate && typeDate) {
                mutate(`${API_URL}meetings${templateMeetingId ? `?meetingTemplateId=${templateMeetingId}` : ""}`);
            }
            return;
        }
    }, [startDate, endDate, typeDate]);

    useEffect(() => {
        if (templateMeetingId && multiMeetings.length > 0) {
            const data = multiMeetings.find(item => item.id === templateMeetingId);
            setSelectMultiMeeting(data ?? multiMeetings[0]);
            setCustomFields(data?.customFields ?? {});
        }
    }, [multiMeetings, templateMeetingId]);


    useEffect(() => {
        if (codeUrl !== (pathname).split('/').pop()) {
            setCodeUrl((pathname).split('/').pop()!)
        }
    }, [pathname])

    useEffect(() => {
        if (templateMeetingId && multiMeetings.length > 0) {
            const data = multiMeetings.find(item => item.id === templateMeetingId)
            setCustomFields(data?.customFields ?? {});
            setSelectMultiMeeting(data!)
            setStartDate(getStartDate(user, companyId, data!))
            setEndDate(getEndDate(user, companyId, data!))
            setTypeDate(getTypeDate(data!))
            setIsMounted(true);
        }
    }, [multiMeetings, templateMeetingId, prevRoute])

    return (
        <>
            <div className="row justify-content-between mb-5">
                {
                    !merchantId &&
                    <>
                        <div className="col-lg-4 col-sm-3 col-xl-5" style={{ alignSelf: "center" }}>
                            <ol className="breadcrumb text-muted fs-6 fw-bold">
                                <li className="breadcrumb-item text-dark">{settings.meeting_title}</li>
                                <li className="breadcrumb-item text-dark">{selectMultiMeeting.name}</li>
                            </ol>
                        </div>
                        <div className="col-lg-8 col-sm-9 col-xl-7">
                            {
                                startDate && endDate && typeDate &&
                                <div className="d-flex float-end px-3">
                                    <Select
                                        styles={{
                                            control: (baseStyles, state) => ({
                                                ...baseStyles,
                                                border: "none", // Menghilangkan simbol garis
                                                backgroundColor: "none",
                                                maxWidth: "200px"
                                            }),
                                            option: (baseStyles, { isSelected, isFocused }) => ({
                                                ...baseStyles,
                                                backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                                cursor: 'pointer'
                                            }),
                                        }}
                                        theme={(theme) => ({
                                            ...theme,
                                            colors: {
                                                ...theme.colors,
                                                primary: 'none',
                                            },
                                        })}
                                        onChange={(data: any) => { setTypeDate(data.value) }}
                                        value={optionsTypeDate.find(option => option.value === typeDate)}
                                        className='react-select-styled z-index-3'
                                        classNamePrefix='react-select'
                                        options={optionsTypeDate}
                                        placeholder='Select an option'
                                        isSearchable={false}
                                    />

                                    <DateRangePicker
                                        style={{ width: "250px" }}
                                        cleanable={false}
                                        character=" - "
                                        format="dd MMM yyyy"
                                        locale={calendarLocale}
                                        value={[startDate, endDate]}
                                        ranges={predefinedRanges}
                                        placement="bottomEnd"
                                        onChange={(value) => {
                                            if (value && value.length === 2) {
                                                setStartDate(value[0]);
                                                setEndDate(value[1]);
                                                setIsMounted(true)
                                            }
                                        }}
                                        showOneCalendar={isMobile}
                                        disabled={loading}
                                        isoWeek={true}
                                        editable={false}
                                    />

                                    <div onClick={() => { mutate(`${API_URL}meetings${templateMeetingId ? `?meetingTemplateId=${templateMeetingId}` : ""}`) }} className="btn btn-light btn-sm ms-2">
                                        <i className="p-0 fa-sync-alt fas"></i>
                                    </div>
                                </div>
                            }
                        </div>
                    </>
                }
            </div>

            <div className={`d-flex ${(user.data.permission_meeting_read !== 'OWNED' && user.data.permission_meeting_read !== 'NONE') && !merchantId ? 'justify-content-between' : 'justify-content-end'}`}>
                {
                    (user.data.permission_meeting_read !== 'OWNED' && user.data.permission_meeting_read !== 'NONE') && !merchantId &&
                    <UserScopeModal
                        user_id={user_id}
                        setUser_id={setUser_id}
                        user_name={user_name}
                        setUser_name={setUser_name}
                        scope={scope} setScope={setScope}
                        permission={user.data.permission_meeting_read}
                        apiURL={`meetings${templateMeetingId ? `?meetingTemplateId=${templateMeetingId}` : ""}`}
                    />
                }

                <div className="d-flex align-items-center">
                    {
                        merchantId &&
                        <Select
                            styles={{
                                control: (baseStyles, state) => ({
                                    ...baseStyles,
                                    borderRadius: "0.475rem",
                                    width: "fit-content",
                                    minWidth: "150px",
                                    boxShadow: 'none',
                                }),
                                option: (baseStyles, { isSelected, isFocused }) => ({
                                    ...baseStyles,
                                    backgroundColor: isSelected ? '#2684FF' : isFocused ? '#dcf2ff' : 'none',
                                    cursor: 'pointer',
                                }),
                                indicatorSeparator: (baseStyles, state) => ({
                                    ...baseStyles,
                                    display: 'none',
                                }),
                                menuList: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: "fit-content",
                                    minWidth: "150px",
                                }),
                                menu: (baseStyles, state) => ({
                                    ...baseStyles,
                                    width: "fit-content",
                                    minWidth: "150px",
                                }),
                            }}
                            theme={(theme) => ({
                                ...theme,
                                colors: {
                                    ...theme.colors,
                                    primary: 'none',
                                },
                            })}
                            onChange={(data: any) => {
                                navigate('/merchants/' + templateMerchantId + "/" + merchantId + '/meetings/' + data.value)
                            }}
                            closeMenuOnSelect={true}
                            placeholder={`Database ${settings.meeting_title}`}
                            options={multiMeetings}
                            value={multiMeetings.find(option => option.value === templateMeetingId)}
                            className="react-select-styled z-index-3 mb-2 me-3"
                        />
                    }
                </div>
            </div>
            <MasterDataTable
                tableKey="meetings"
                tableColumns={tableColumnsWithCustomFields}
                actions={actions}
                apiURL={`meetings${templateMeetingId ? `?meetingTemplateId=${templateMeetingId}` : ""}`}
                dateStart={moment(startDate).toISOString(true)}
                dateEnd={moment(endDate).add(1, 'days').toISOString(true)}
                customParams={typeDate}
                user_id={user_id}
                merchantId={merchantId}
                scope={scope}
                setLoading={setLoading}
                orderBy={7}
                order="desc"
                onRowClicked={onRowClicked}
                autoReload={false}
            />

            {
                showDetailModal && <DetailMeeting data={meeting ? meeting : {} as Meeting} />
            }
            {
                showDetailVisitModal && <DetailVisit data={meeting!} />
            }
            {
                showAddPipelineModal && <AddPipeline meeting={meeting!} merchantId={[meeting?.merchant_id!]} />
            }
            {
                showAddReimbursementModal && <AddReimbursement meeting={meeting!} />
            }
            {
                showAttachmentCustomFieldModal && <MeetingAttachments title={customFields[key].name!} meeting={meeting!} url={url} />
            }
            {
                showUpdateModal && <UpdateMeeting codeUrl={templateMeetingId as string || ''} meeting={meeting!} />
            }
            {
                showUpdateStatusModal && <UpdateStatusMeeting codeUrl={templateMeetingId as string || ''} meeting={meeting!} />
            }
            {
                showDeleteModal && <DeleteMeeting meeting={meeting!} setVisit={setVisit} />
            }
            {
                showMapModal && <MapMeeting latitude={latitudeMap} longitude={longitudeMap} meeting={meeting!} />
            }
            {
                showAttachmentModal && <MeetingAttachments meeting={meeting!} />
            }
            {
                showModalAddScheduleMeeting && typeMeeting === 'schedule' && <AddScheduleMeeting
                    startDate={startDate ?? startOfMonth(today)}
                    endDate={endDate ?? endOfMonth(today)}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    customFields={customFields}
                    setCustomFields={setCustomFields}
                    typeMeeting={typeMeeting}
                    setTypeMeeting={setTypeMeeting}
                    usersData={usersData}
                    usersLoading={usersLoading}
                    users={users}
                    labels={labels}
                    usersCompany={usersCompany}
                    usersCompanyLoading={usersCompanyLoading}
                />
            }
            {
                showModalAddReportMeeting && typeMeeting === 'report' && <AddReportMeeting
                    startDate={startDate ?? startOfMonth(today)}
                    endDate={endDate ?? endOfMonth(today)}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    customFields={customFields}
                    setCustomFields={setCustomFields}
                    typeMeeting={typeMeeting}
                    setTypeMeeting={setTypeMeeting}
                    usersData={usersData}
                    usersLoading={usersLoading}
                    users={users}
                    labels={labels}
                    usersCompany={usersCompany}
                    usersCompanyLoading={usersCompanyLoading}
                />
            }
            {
                showModalAddVisitMeeting && typeMeeting === 'visit' && <AddVisitMeeting
                    startDate={startDate ?? startOfMonth(today)}
                    endDate={endDate ?? endOfMonth(today)}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    customFields={customFields}
                    setCustomFields={setCustomFields}
                    typeMeeting={typeMeeting}
                    setTypeMeeting={setTypeMeeting}
                    usersData={usersData}
                    usersLoading={usersLoading}
                    users={users}
                    labels={labels}
                    usersCompany={usersCompany}
                    usersCompanyLoading={usersCompanyLoading}
                    setVisit={setVisit}
                />
            }
            {
                showModalAddScheduleVisitMeeting && typeMeeting === 'schedule-visit' && <AddScheduleVisitMeeting
                    startDate={startDate ?? startOfMonth(today)}
                    endDate={endDate ?? endOfMonth(today)}
                    setStartDate={setStartDate}
                    setEndDate={setEndDate}
                    customFields={customFields}
                    setCustomFields={setCustomFields}
                    typeMeeting={typeMeeting}
                    setTypeMeeting={setTypeMeeting}
                    usersData={usersData}
                    usersLoading={usersLoading}
                    users={users}
                    labels={labels}
                    usersCompany={usersCompany}
                    usersCompanyLoading={usersCompanyLoading}
                />
            }
            {
                showModalApproval && <ModalApprovalMeeting meeting={meeting!} type={typeApproval} customFields={customFields} />
            }
            {
                showModalReject && <ModalApprovalMeeting meeting={meeting!} type={typeApproval} customFields={customFields} />
            }
            {
                showModalClockIn && <ModalClockInMeeting meeting={meeting!} setVisit={setVisit} />
            }
            {
                showModalUpdateVisitSchedule && <UpdateVisitScheduleMeeting meeting={meeting!} customFields={customFields} labels={labels} />
            }
        </>
    )
}

export { MasterMeetingsContent }